import { useTranslation } from 'i18n';

const isoDate = (d) => d.toISOString().slice(0, 10);

/** Earliest bookable date for a service (today + lead days). */
export function earliestBookingDate(info) {
  const d = new Date();
  d.setDate(d.getDate() + Number(info?.service_lead_days || 0));
  return isoDate(d);
}

/** Service: preferred date + time window + notes (+ optional measurements). */
export default function BookingFields({ value, onChange, info }) {
  const { t } = useTranslation();
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const input = 'mt-1 w-full rounded-xl border border-border bg-surface px-3 py-2 text-sm text-text';
  return (
    <fieldset className="space-y-3 rounded-2xl border border-border bg-surface-2 p-4" data-testid="booking-fields">
      <legend className="px-1 text-sm font-semibold text-text">{t('listing.bookingTitle')}</legend>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="text-xs font-medium text-muted">
          {t('listing.preferredDate')}
          <input type="date" className={input} min={earliestBookingDate(info)} value={value.date || ''} onChange={set('date')}
            data-testid="booking-date" required />
        </label>
        <label className="text-xs font-medium text-muted">
          {t('listing.timeWindow')}
          <select className={input} value={value.window || ''} onChange={set('window')} data-testid="booking-window" required>
            <option value="">{t('listing.chooseWindow')}</option>
            {['morning', 'afternoon', 'evening'].map((w) => <option key={w} value={w}>{t(`listing.window.${w}`)}</option>)}
          </select>
        </label>
      </div>
      <label className="block text-xs font-medium text-muted">
        {t('listing.notes')}
        <textarea rows={2} maxLength={500} className={input} value={value.notes || ''} onChange={set('notes')} data-testid="booking-notes" />
      </label>
      <label className="block text-xs font-medium text-muted">
        {t('listing.measurements')}
        <textarea rows={2} maxLength={1000} className={input} value={value.measurements || ''} onChange={set('measurements')} />
      </label>
    </fieldset>
  );
}

/** "Mon 3 Nov · Evening · Collar 15in" under a cart/order line. */
export function bookingSummary(booking, t) {
  if (!booking) return null;
  const parts = [booking.date, booking.window ? t(`listing.window.${booking.window}`) : null, booking.notes].filter(Boolean);
  return parts.join(' · ');
}
